// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__zcWEy","table":"styles_table__hC5yM"};